// extracted by mini-css-extract-plugin
export default {"button":"GenericButton_button__D6aob"};